export const confirmNavigationProceed = () =>
  window.confirm('You have unsaved changes. Are you sure you want to continue ?');
